export const schoolClassKeys = {
  all: ['schoolclass'] as const,
  lists: () => [...schoolClassKeys.all, 'list'] as const,
  list: (tenantId?: number | null) => [...schoolClassKeys.lists(), tenantId] as const,
};
